import { render } from "./ProjectsModal.vue?vue&type=template&id=7a64e43b&scoped=true&ts=true"
import script from "./ProjectsModal.vue?vue&type=script&lang=ts"
export * from "./ProjectsModal.vue?vue&type=script&lang=ts"

import "./ProjectsModal.vue?vue&type=style&index=0&id=7a64e43b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a64e43b"]])

export default __exports__